import React from 'react';

/**
 * VODReplayBadge - Small badge shown during VOD playback
 * Replaces the live scoreboard overlay with a minimal final score display
 */
export function VODReplayBadge({ 
  game,
  position = 'top-left'
}) {
  if (!game) return null;

  const positionClasses = {
    'top-left': 'top-3 left-3',
    'top-right': 'top-3 right-3',
    'bottom-left': 'bottom-16 left-3',
    'bottom-right': 'bottom-16 right-3'
  };

  const homeScore = game.score?.home ?? game.final_score?.home ?? 0;
  const awayScore = game.score?.away ?? game.final_score?.away ?? 0;
  
  // Get team abbreviation (first 3 letters)
  const getTeamAbbr = (teamName) => {
    if (!teamName) return '---';
    const cleaned = teamName.replace(/^(The |Team )/i, '');
    return cleaned.substring(0, 3).toUpperCase();
  };

  const homeAbbr = getTeamAbbr(game.home_team_name);
  const awayAbbr = getTeamAbbr(game.away_team_name);

  return (
    <div 
      className={`absolute ${positionClasses[position]} z-20 pointer-events-none`}
      data-testid="vod-replay-badge"
    >
      <div className="bg-black/80 backdrop-blur-sm rounded-lg px-3 py-2 shadow-lg">
        {/* REPLAY Badge */}
        <div className="flex items-center justify-center mb-1">
          <span className="text-xs font-semibold text-zinc-400 tracking-wider">
            REPLAY
          </span>
        </div>
        
        {/* Final Score */}
        <div className="flex items-center gap-2 text-white">
          <span className="font-semibold text-sm">{homeAbbr}</span>
          <span className="font-bold text-lg tabular-nums">{homeScore}</span>
          <span className="text-zinc-500">-</span>
          <span className="font-bold text-lg tabular-nums">{awayScore}</span>
          <span className="font-semibold text-sm">{awayAbbr}</span>
        </div>
        
        {/* FINAL indicator */}
        <div className="flex items-center justify-center mt-1">
          <span className="text-xs font-medium text-zinc-500">
            FINAL
          </span>
        </div>
      </div>
    </div>
  );
}

export default VODReplayBadge;
